require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = function _default() {
  return _react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, _react["default"].createElement("path", {
    d: "M10 6.668l-3.332 6.664V40H15v5h6.668l5-5h6.664l10-10V6.668zm30 21.664l-5 5H25l-5 5v-5h-6.668V10H40zm0 0"
  }), _react["default"].createElement("path", {
    d: "M31.668 26.668h-3.336V15h3.336zm-6.668 0h-3.332V15H25zm0 0"
  }));
};

exports["default"] = _default;